import { createSlice } from "@reduxjs/toolkit";
import {
  fetchlesson3dModeling,
  fetchlesson3dPrinting,
  fetchlessonBatteries,
  fetchlessonBrushedBrushless,
  fetchlessonelectricalEngineer,
  fetchlessonESCsBESCEs,
  fetchlessonFusion,
  fetchlessonGearRatios,
  fetchlessonMaterialscience,
  fetchlessonPCBs,
  fetchlessonPhysicsgeometry,
  fetchlessonReceivers,
  fetchlessonSlicing,
  fetchlessonSoldering,
  fetchlessonThinkercad,
  fetchlessonWeaponPhysics,
  transformLessonData,
} from "../action/lessonsAction";

const initialState = {
  isLoading: false,
  electricalEngineeringList: [],
  pcbsList: [],
  eSCsBESCEsList: [],
  batteriesList: [],
  receiversList: [],

  physicsgeometryList: [],
  materialscienceList: [],
  solderingList: [],
  brushedBrushlessList: [],
  weaponPhysicsList: [],
  gearRatiosList: [],
  model3DList: [],
  thinkercadList: [],
  fusionList: [],
  model3DPrintingList: [],
  slicingList: [],
};

const lessonSlice = createSlice({
  name: "lesson",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // "fetch-lessons-electrical-engineer"
    builder.addCase(
      fetchlessonelectricalEngineer.fulfilled,
      (state, action) => {
        const { data } = action?.payload || {};
        state.electricalEngineeringList = transformLessonData(data);

        state.isLoading = false;
      }
    );
    builder.addCase(fetchlessonelectricalEngineer.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchlessonelectricalEngineer.rejected, (state, action) => {
      state.isLoading = false;
    });

    // "fetch-lessons-PCBs"
    builder.addCase(fetchlessonPCBs.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.pcbsList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchlessonPCBs.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchlessonPCBs.rejected, (state, action) => {
      state.isLoading = false;
    });

    // "fetch-lessons-ESCsBESCEs"
    builder.addCase(fetchlessonESCsBESCEs.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.eSCsBESCEsList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchlessonESCsBESCEs.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchlessonESCsBESCEs.rejected, (state, action) => {
      state.isLoading = false;
    });

    // "fetch-lessons-batteries"
    builder.addCase(fetchlessonBatteries.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.batteriesList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchlessonBatteries.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchlessonBatteries.rejected, (state, action) => {
      state.isLoading = false;
    });

    // "fetch-lessons-receivers"
    builder.addCase(fetchlessonReceivers.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.receiversList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchlessonReceivers.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchlessonReceivers.rejected, (state, action) => {
      state.isLoading = false;
    });

    // "fetch-lessons-physics-geometry"
    builder.addCase(fetchlessonPhysicsgeometry.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.physicsgeometryList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchlessonPhysicsgeometry.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchlessonPhysicsgeometry.rejected, (state, action) => {
      state.isLoading = false;
    });

    // "fetch-lessons-material-science"
    builder.addCase(fetchlessonMaterialscience.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.materialscienceList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchlessonMaterialscience.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchlessonMaterialscience.rejected, (state, action) => {
      state.isLoading = false;
    });

    // "fetch-lessons-soldering"
    builder.addCase(fetchlessonSoldering.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.solderingList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchlessonSoldering.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchlessonSoldering.rejected, (state, action) => {
      state.isLoading = false;
    });

    // "fetch-lessons-brushed-brushless"
    builder.addCase(fetchlessonBrushedBrushless.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.brushedBrushlessList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchlessonBrushedBrushless.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchlessonBrushedBrushless.rejected, (state, action) => {
      state.isLoading = false;
    });

    // "fetch-lessons-weapon-physics"
    builder.addCase(fetchlessonWeaponPhysics.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.weaponPhysicsList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchlessonWeaponPhysics.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchlessonWeaponPhysics.rejected, (state, action) => {
      state.isLoading = false;
    });

    // "fetch-lessons-gear-ratios"
    builder.addCase(fetchlessonGearRatios.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.gearRatiosList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchlessonGearRatios.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchlessonGearRatios.rejected, (state, action) => {
      state.isLoading = false;
    });

    // "fetch-lessons-3d-modling"
    builder.addCase(fetchlesson3dModeling.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.model3DList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchlesson3dModeling.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchlesson3dModeling.rejected, (state, action) => {
      state.isLoading = false;
    });

    // "fetch-lessons-thinkercad"
    builder.addCase(fetchlessonThinkercad.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.thinkercadList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchlessonThinkercad.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchlessonThinkercad.rejected, (state, action) => {
      state.isLoading = false;
    });

    // "fetch-lessons-fusion"
    builder.addCase(fetchlessonFusion.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.fusionList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchlessonFusion.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchlessonFusion.rejected, (state, action) => {
      state.isLoading = false;
    });

    //"fetch-lessons-3d-printing"
    builder.addCase(fetchlesson3dPrinting.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.model3DPrintingList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchlesson3dPrinting.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchlesson3dPrinting.rejected, (state, action) => {
      state.isLoading = false;
    });

    // "fetch-lessons-slicing"
    builder.addCase(fetchlessonSlicing.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.slicingList = transformLessonData(data);
      state.isLoading = false;
    });
    builder.addCase(fetchlessonSlicing.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchlessonSlicing.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export default lessonSlice.reducer;
